module.exports = __webpack_public_path__ + "static/media/ellipsis-blue.c6e4ff2e.svg";